function setupResponseBoxContainers(){
    var responseType = columnForTrial('responseType', trialRow);
    if (columnForTrial('responsePos', trialRow) == 'na' && !responseType.includes('box*')) {
        resetResponseBox();
        return;
    }

    const stimuliBoundaries = getStimuliBoundaries();
    var boxPositions = getResponseBoxPositions();

    //setup below container
    if(boxPositions["below"] != undefined){
        var belowContainer = document.getElementById("responseBoxBelowContainer");
        belowContainer.style.top = currentButtonTop + "px";
        belowContainer.style.listStyle = "none";
        setupHorizontalResponseBoxContainer(belowContainer, boxPositions["below"]);
    }

    //setup top container
    if(boxPositions["above"] != undefined){
        var aboveContainer = document.getElementById("responseBoxAboveContainer");
        aboveContainer.style.listStyle = "none";
        if(columnForTrial('trialText', trialRow) != 'na'){
            aboveContainer.style.top = parseInt($('#trialText').css('top')) - $(responseBoxes[0]).height() - 10 + "px";    
        }
        else{
            aboveContainer.style.top = stimuliBoundaries.top - $(responseBoxes[0]).height() + "px";
        }
        setupHorizontalResponseBoxContainer(aboveContainer, boxPositions["above"]);
    }

    //setup left container
    if(boxPositions["left"] != undefined){
        var leftContainer = document.getElementById("responseBoxLeftContainer");
        leftContainer.style.left = getStimuliBoundaries().left - $(responseBoxes[0]).width() - 10 + "px";
        setupVerticalResponseBoxContainer(leftContainer, boxPositions["left"]);
    }

    //setup right container
    if(boxPositions["right"] != undefined){
        var rightContainer = document.getElementById("responseBoxRightContainer");
        rightContainer.style.left = getStimuliBoundaries().right + 20 + "px";
        setupVerticalResponseBoxContainer(rightContainer, boxPositions["right"]);
    }

    for(var i in boxPositions){
        if(!["above","left","below","right"].includes(i)){
            setupRelativeResponseBox(i, boxPositions[i][0]);
        }
    }
}

function setupHorizontalResponseBoxContainer(container, responseBoxes){
    const stimuliBoundaries = getStimuliBoundaries();
    var responseBoxWidth = window.responseBoxes[0].getBoundingClientRect().width - (15 * responseBoxes.length);
    container.style.height = window.responseBoxes[0].getBoundingClientRect().height;
    container.style.width = responseBoxWidth * responseBoxes.length + "px";
    //container.style.width = responseBoxes.length * (maxImageWidth + 10) + "px";
    const displayScreenSize = document.getElementById('displayScreen').getBoundingClientRect();
    container.style.left = (displayScreenSize.width / 2 - (responseBoxWidth * responseBoxes.length)/ 2) + "px";
    console.log('responseBox Vertical Setup called', responseBoxes);
    for(var i = 0; i < responseBoxes.length; i++){
        responseBoxes[i].style.position = "";
        responseBoxes[i].style.display = "inline-block";
        responseBoxes[i].style.top = "";
        responseBoxes[i].style.left = "";
        responseBoxes[i].style.width = responseBoxWidth + "px";
        container.append(responseBoxes[i]);
    }
}

function setupVerticalResponseBoxContainer(container, responseBoxes){
    const stimuliBoundaries =  getStimuliBoundaries();
    var responseBoxWidth = window.responseBoxes[0].getBoundingClientRect().width - (15 * responseBoxes.length);
    container.style.listStyle = "none";
    container.style.height = stimuliBoundaries.bottom - stimuliBoundaries.top + "px";
    container.style.width = responseBoxes[0].style.width;
    container.style.top = stimuliBoundaries.top + "px";
    console.log('responseBox Horizontal setup called',container, responseBoxes);
    for(var i = 0; i < responseBoxes.length; i++){
        responseBoxes[i].style.position = "";
        responseBoxes[i].style.top = "";
        responseBoxes[i].style.left = "";
        responseBoxes[i].style.width = responseBoxWidth + "px";
        container.append(responseBoxes[i]);
    }
}

function setupRelativeResponseBox(position, responseBox){
    var responseBoxWidth = getStimuliBoundaries().left - 10;
    position = position.split(' ');
    responseBox.style.position = "absolute";
    responseBox.style.left = halfCanvasWidth - $(responseBox).width() / 2 + parseInt(position[0]) + "px";
    responseBox.style.top = halfCanvasHeight - $(responseBox).height() / 2 + parseInt(position[1]) + "px";
    responseBox.style.width = responseBoxWidth + "px";
    var displayScreen = document.getElementById('displayScreen');
    displayScreen.append(responseBox);
}

function getResponseBoxPositions(){
    var boxPositions = {};
    const responseBoxCount = getInputBoxesForTrial(trialRow);
    var options = columnForTrial('responsePos', trialRow);
    if(options == "na"){
        boxPositions["below"] = [];
        for(var i = 0; i < responseBoxCount; i++){
            boxPositions["below"].push(responseBoxes[i]);
        }
        return boxPositions;
    }
    options = options.split(';');

    if(options.length > 1){
        for(var i = 0; i < options.length; i++){
            if(!boxPositions[options[i]]){
                boxPositions[options[i]] = [];
            }
            boxPositions[options[i]].push(responseBoxes[i]);
        }
    }
    else if(options.length == 1){
        boxPositions[options[0]] = [];
        for(var i = 0; i < responseBoxCount; i++){
            boxPositions[options[0]].push(responseBoxes[i]);
        }
    }
    return boxPositions;
}

function getStimuliBoundaries(){
    var boundaries = {left: 10e9, right: 0, top: 10e9, bottom: 0};
    var positions = getStimuliPositions();

    //no visible stimuli
    if(positions.length == 0){
        boundaries.left = window.innerWidth/2 - 50;
        boundaries.right = boundaries.left + 100;
        boundaries.top = window.innerHeight/2 - 50;
        boundaries.bottom = boundaries.top + 100;
        return boundaries;
    }
    if(isTrialOfType(trialRow, 'video')){
        positions = computeVideoPositions();
    }
    console.log('boundaries: trial: ', columnForTrial('responsePos', trialRow), trialRow, positions, stimContainers );
    for(var i in positions){
        if(positions[i]){
            if(positions[i].left < boundaries.left){
                boundaries.left = positions[i].left;
            }

            if(positions[i].left + positions[i].width > boundaries.right){
                boundaries.right = parseInt(positions[i].left) + parseInt(positions[i].width);
            }

            if(positions[i].top < boundaries.top){
                boundaries.top = positions[i].top;
            }

            if(positions[i].top + positions[i].height > boundaries.bottom){
                boundaries.bottom = parseInt(positions[i].top) + parseInt(positions[i].height);
            }
        }
    }

    function getStimuliPositions(){
        var displayScreenRect = document.getElementById('displayScreen').getBoundingClientRect();

        var positions = [];
        for(var i = 0; i < window.stimContainers.length; i++){
            if(window.stimContainers[i].style.display == 'none'){
                continue;
            }

            var currentBounds = window.stimContainers[i].getBoundingClientRect();
            var currentPosition = {
                left: currentBounds.x - displayScreenRect.x,
                top: currentBounds.y - displayScreenRect.y,
                height: currentBounds.height,
                width: currentBounds.width
            };

            positions.push(currentPosition);
        }
        return positions;
    }


    return boundaries;
}

function computeVideoPositions(){
    var videoPositions = [];
    var count = listTrialScreensTimings[trialRow].length;
    for (var i = 1; i < count+1; i++) {
        var currentVideo = "#video" + i;
        var currentVideoPosition = {};
        currentVideoPosition.left = parseInt($(currentVideo).css('left'));
        currentVideoPosition.top = parseInt($(currentVideo).css('top'));
        currentVideoPosition.height = parseInt($(currentVideo).css('height'));
        currentVideoPosition.width = parseInt($(currentVideo).css('width'));

        videoPositions[i] = currentVideoPosition;
    };
    return videoPositions;
}

function resetResponseBox(){
    $('#displayScreen').prepend($('#responseBox'));
    $('#responseBox').css('position', 'absolute');
    setResponseTopPosition();//compute where we should display the buttons
    buttonsContainers[0].style.top = currentButtonTop + "px";
    buttonsContainers[0].style.width = "";
    buttonsContainers[0].style.left = (canvasWidth/2 - $('#responseBox').width()/2) + "px";
}